module.exports = __webpack_public_path__ + "static/img/tabela.17db450.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/spremidos-citrus/tabela.png
// module id = YLsl
// module chunks = 0